'use client';

import { createContext, useContext } from 'react';

/**
 * 문제 신고 창을 여는 손잡이. 화면마다 `IssueReportProvider` 가 하나 두고, 사이드바·편집기 머리의 「문제 신고」와
 * 모든 모달 왼쪽 아래 아이콘이 이것으로 같은 창을 연다(10-01 데모 R9).
 *
 * null 이면 지금 화면은 신고할 수 없다(신고자를 아직 모름 - 로그인 전·작성 링크 확인 전). 아이콘은 그리지 않고,
 * 머리말 단추는 자리를 지킨 채 잠긴다.
 *
 * 창(`IssueReportDialog`)과 파일을 나눈 까닭: 공용 모달 틀(`components/ui/dialog.tsx`)이 이 손잡이를 읽는데,
 * 신고 창도 그 틀로 그려진다 - 한 파일이면 서로를 불러들인다.
 */
export interface IssueReportOpener {
  open: () => void;
}

export const IssueReportContext = createContext<IssueReportOpener | null>(null);

export function useIssueReport(): IssueReportOpener | null {
  return useContext(IssueReportContext);
}
